// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZUoC4","content":"styles_content__1aws9","row":"styles_row__3QhUD","footer":"styles_footer__Lu3ih","phraseLength":"styles_phraseLength__3pky2"};